import CheckoutPage from "@containers/Checkout/Checkout.jsx";
import SuccessPage from "@containers/SuccessPage.jsx";
import FailurePage from "@containers/FailurePage.jsx";

export const PublicRoutes = [
  {
    path: "/",
    element: <CheckoutPage />,
    key: "/",
  },
  {
    path: "/success",
    element: <SuccessPage />,
    key: "/success",
  },
  {
    path: "/failure",
    element: <FailurePage />,
    key: "/failure",
  },
];
